/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Csv_Unsupported_EncodingInputs */

const en_toast_csv_unsupported_encoding = /** @type {(inputs: Toast_Csv_Unsupported_EncodingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsupported CSV encoding`)
};

const nl_toast_csv_unsupported_encoding = /** @type {(inputs: Toast_Csv_Unsupported_EncodingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niet-ondersteunde CSV-codering`)
};

/**
* | output |
* | --- |
* | "Unsupported CSV encoding" |
*
* @param {Toast_Csv_Unsupported_EncodingInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const toast_csv_unsupported_encoding = /** @type {((inputs?: Toast_Csv_Unsupported_EncodingInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Csv_Unsupported_EncodingInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_toast_csv_unsupported_encoding(inputs)
	return en_toast_csv_unsupported_encoding(inputs)
});